import { render, staticRenderFns } from "./standard-dropdown-list-multiple.vue?vue&type=template&id=0823eb9a&scoped=true"
import script from "./standard-dropdown-list-multiple.vue?vue&type=script&lang=js"
export * from "./standard-dropdown-list-multiple.vue?vue&type=script&lang=js"
import style0 from "./standard-dropdown-list-multiple.vue?vue&type=style&index=0&id=0823eb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823eb9a",
  null
  
)

export default component.exports